import ProductPageContainer from "../../../../Components/Applications/ECommerce/ProductPage/ProductPageContainer";

const ProductPage = () => {
  return <ProductPageContainer />;
};

export default ProductPage;
